import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector } from 'js/store/hooks';
import { useNavigate } from 'js/hooks/navigate';
import React, { memo, useCallback } from 'react';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import * as Types from './types';

import style from './GameMoreInfo.scss';

export const GameMoreInfo: React.FC<Types.IGameMoreInfoProps> = ({ className = '', game }) => {
    const navigate = useNavigate();
    const translate = useTranslations();
    const gamesGridGameInfoPageURL = useAppSelector(prop('gamesGridGameInfoPageURL'));

    const onGameInfoClick = useCallback(() => {
        if (gamesGridGameInfoPageURL) {
            navigate(`${gamesGridGameInfoPageURL}/${game.seoFriendlyGameName || game.gameCode}`, undefined, { preserveHash: true });
        }
    }, [gamesGridGameInfoPageURL, navigate, game]);

    return (
        <AccessibilityElement
            onClick={onGameInfoClick}
            aria-label={translate('playtech.mobile.system.games-grid.game.gameInfo.aria-label')}
            className={`${style.gameInfoIcon} ${className} cms-games-grid-game-more-info-icon`}
        />
    );
};

export const GameFavoriteIcon = memo(GameMoreInfo);
